<template>
    <el-form :model="form" :rules="rules" ref="form" label-position="left" label-width="150px" size="small" class="invoice-check" v-if="show">
        <div class="detail-row footer">
            <div class="detail-block">
                <h3 v-if="invoice.typ === 4">核銷</h3>
                <h3 v-else-if="invoice.typ === 1">INVOICE開立</h3>
                <h3 v-else>發票開立</h3>
                <el-form-item prop="foO_DAT">
                    <template slot="label">
                        <span v-if="invoice.typ === 4">核銷日期</span>
                        <span v-else-if="invoice.typ === 1">INVOICE日期</span>
                        <span v-else>發票日期</span>
                        <ahTip>此為營業收入分析的日期依據</ahTip>
                    </template>
                    <div>
                        <el-date-picker v-model="form.foO_DAT" value-format="timestamp" type="date" placeholder="請選擇" @change="handleFooDateChange"> </el-date-picker>
                        <el-alert
                            v-if="!(invoice.typ === 4 || invoice.typ === 1) && newestInvoiceDate"
                            type="warning"
                            size="small"
                            :closable="false"
                            class="small-alert"
                            style="
                                display: inline-block;
                                margin-left: 10px;
                                line-height: 30px;
                                max-width: 200px;
                                padding: unset;
                                vertical-align: top;
                            "
                            >最新發票日期：{{ newestInvoiceDate | dateFormater("YYYY / MM / dd") }}</el-alert
                        >
                    </div>
                    <div>
                        <el-alert v-if="isFutureInvoiceDate" type="warning" size="small" :closable="false" class="future-invoice-alert">
                            開立發票相關規定請至 財政部（<a href="https://law-out.mof.gov.tw/LawContent.aspx?id=FL006084" target="_blank"> 連結 </a>）查詢
                        </el-alert>
                    </div>
                </el-form-item>
                <el-form-item
                    v-if="invoice.typ !== 4"
                    prop="foo"
                    :label="invoice.typ === 1 ? '自訂單號' : '發票號碼'"
                    :rules="
                        invoice.typ === 1
                            ? [
                                  {
                                      required: true,
                                      message: '請填寫自訂單號',
                                      trigger: 'blur'
                                  }
                              ]
                            : rules.foo
                    "
                >
                    <template v-if="invoice.typ !== 1">
                        <ahElInputInvoice v-model="form.foo" :key="form.foO_DAT" show-duplicate-hint :check-date="form.foO_DAT" :ioo="form.ioo" />
                        <ah-receipt-input v-model="form.foo" :suggestion-only="true" :presets="fooPrefixs"></ah-receipt-input>
                    </template>
                    <template v-else>
                        <el-input v-model="form.foo" :maxlength="20" show-word-limit style="width: 300px"></el-input>
                    </template>
                </el-form-item>

                <el-form-item v-if="invoice.cny !== 'TWD'" label="兌換台幣匯率">
                    <div>
                        <el-radio-group v-model="ratType" @input="onRatTypeChange" size="mini">
                            <el-radio-button :label="1">申請時匯率</el-radio-button>
                            <el-radio-button :label="2">即時匯率</el-radio-button>
                            <el-radio-button :label="3">自訂匯率</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div>
                        <MoneyInput v-model="form.rat" :precision="4" style="width: 93px; margin-top: 5px;" :disabled="ratType !== 3" size="small" />
                    </div>
                </el-form-item>
                <el-form-item v-if="invoice.cny !== 'TWD'" label="約當台幣">
                    <Money :v="Math.round(invoice.amt * form.rat)" /> TWD
                </el-form-item>
                <el-form-item prop="incomeItemNo" label="收入項目">
                    <template slot="label"> 收入項目 </template>
                    <ahSelectVariableStateItem :enableType="['invoice']" v-model="form.incomeItemNo" @change="onVariableStateItemChange"></ahSelectVariableStateItem>
                </el-form-item>
                <el-form-item v-if="isAhSuggestAccountingItemsSelectorShow" prop="accno" label="立帳科目">
                    <ahSuggestAccountingItemsSelector ref="ahSuggestAccountingItemsSelector" v-model="form.accno" @loaded="onAhSuggestAccountingItemsSelectorLoaded"></ahSuggestAccountingItemsSelector>
                </el-form-item>
                <el-form-item v-if="isAhSuggestAccountingItemsSelectorShow" prop="clearanceAccno" label="沖帳科目">
                    <ah-select-accounting-setting v-model="form.clearanceAccno" width="200px" :allowedGroups="['assetsSettings', 'norSettings']" />
                </el-form-item>
                <el-form-item prop="comment" label="備註">
                    <el-input v-model="form.comment" type="textarea" :rows="3" maxlength="200" show-word-limit></el-input>
                </el-form-item>
            </div>
            <div id="invoice-detail-check-anchor"></div>
            <div style="text-align: right; padding: 15px 0 10px 0">
                <el-button type="" @click="handleCancel">取消</el-button>
                <el-button type="success" @click="handleSubmit" class="primary-action" :loading="isSubmitting">
                    <span v-if="invoice.typ !== 4">送出開立</span>
                    <span v-if="invoice.typ === 4">送出核銷</span>
                </el-button>
            </div>
        </div>
    </el-form>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import ahSelectVariableStateItem from '@/components/ui/ahSelectVariableStateItem.vue';
import ahElInputInvoice from '@/components/ui/ahElInputInvoice.vue';
import ahReceiptInput from '@/components/ui/ahReceiptInput.vue';
import invoiceSerialNumber from '@/assets/commonData/invoiceSerialNumber';
import ahSuggestAccountingItemsSelector from '@/components/ui/ahSuggestAccountingItemsSelector.vue';
import ahSelectAccountingSetting from '@/components/ui/ahSelectAccountingSetting.vue';

export default {
    name: 'invoice-check',
    props: ['show', 'invoice', 'auditProgress'],
    components: {
        ahSelectVariableStateItem,
        ahElInputInvoice,
        ahReceiptInput,
        ahSuggestAccountingItemsSelector,
        ahSelectAccountingSetting,
    },
    computed: {
        isFutureInvoiceDate() {
            const TODAY = moment().startOf('day');
            return moment(this.form.foO_DAT).isAfter(TODAY);
        },
    },
    data() {
        const invoiceValidate = (rule, value, callback) => {
            if (!value) callback(new Error('請填寫發票號碼'));
            else if (value.length < 10) callback(new Error('請輸入完整發票號碼'));
            callback();
        };

        return {
            isAhSuggestAccountingItemsSelectorShow: true,

            isSubmitting: false,
            newestInvoiceDate: null,
            fooPrefixs: [],
            suggestAccountItems: [],
            ratType: 1,
            form: {
                invoiceSno: this.sno,
                foO_DAT: null,
                rat: 1,
                foo: null,
                iteM_parent_SNO: null, // api 不會用到，前端選單使用
                incomeItemNo: null,
                accno: null,
                clearanceAccno: null,
                comment: null,
                auditProgress: {
                    sno: this.auditProgress ? this.auditProgress.sno : null,
                    sot: this.auditProgress ? this.auditProgress.sot : null,
                    fin: 1,
                    rsn: null,
                    menU_UNT: this.auditProgress ? this.auditProgress.menU_UNT : '',
                },
            },
            rules: {
                incomeItemNo: [
                    {
                        required: true,
                        message: '請選擇收入項目',
                        trigger: 'blur',
                    },
                ],
                foo: [
                    {
                        required: true,
                        validator: invoiceValidate,
                        trigger: 'blur',
                    },
                ],
                foO_DAT: [
                    {
                        required: true,
                        message: '請選擇日期',
                        trigger: 'blur',
                    },
                ],
            },
            expireTimeOption: {
                disabledDate(date) {
                    return date.getTime() >= Date.now();
                },
            },
        };
    },
    watch: {
        invoice(newVal) {
            if (newVal) {
                console.log('newV', newVal);
                this.form.rat = newVal.rat;
                this.form.invoiceSno = newVal.sno;
                this.form.foo = newVal.foo;
                this.form.foO_DAT = newVal.foO_PDAT ? newVal.foO_PDAT : null;
                this.form.incomeItemNo = newVal.incomeItemNo;
                this.form.comment = newVal.comment;
                this.form.accno = newVal.accno;
                this.form.clearanceAccno = newVal.clearanceAccno ? newVal.clearanceAccno : '1130';

                // 發票日期不可超過今天
                const now = new Date();
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
                if (this.form.foO_DAT > today) {
                    this.form.foO_DAT = today;
                }

                // 核銷（沒有發票日期）
                if (newVal.typ === 4) {
                    this.form.foO_DAT = this.form.foO_DAT ? this.form.foO_DAT : this.form.pdat;
                    if (this.form.foO_DAT < 946684800000) {
                        this.form.foO_DAT = null;
                    }
                }

                // 待處理
                this.form.iteM_SNO = null;
            }
        },
        show(newVal) {
            if (newVal) {
                this.fetchNewestInvoiceDate();

                // 取得字軌號碼
                this.fetchSerialNumber(this.form.foO_DAT);
            }
        },
        auditProgress(newVal) {
            this.form.auditProgress = {
                sno: newVal ? newVal.sno : null,
                sot: newVal ? newVal.sot : null,
                fin: 1,
                rsn: null,
                menU_UNT: newVal ? newVal.menU_UNT : '',
            };
        },
    },
    methods: {
        initAuSuggestAccountingItemsSelector() {
            if (this.form.incomeItemNo) {
                this.isAhSuggestAccountingItemsSelectorShow = true;
                this.$nextTick(() => {
                    this.$refs.ahSuggestAccountingItemsSelector.init(this.form.incomeItemNo);
                });
                console.log('sss', this.form);
            } else this.isAhSuggestAccountingItemsSelectorShow = false;

            this.suggestAccountItems = [];
        },
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },

        handleFooDateChange() {
            this.fetchSerialNumber(this.form.foO_DAT);
        },
        fetchSerialNumber(datetime) {
            if (datetime && datetime > 946684800000) {
                this.$api({
                    url: 'InvoiceManagemnetPage/GetPrefix',
                    params: { DAT: datetime },
                    method: 'GET',
                }).then((resp) => {
                    if (resp.data.prefixs.length > 0) {
                        this.fooPrefixs = _.filter(resp.data.prefixs, ['prefixType', 1]);
                        // this.form.foo = resp.data.prefixs[resp.data.prefixs.length - 1];
                    }
                });
            }
        },
        // 取得最後發票日期
        fetchNewestInvoiceDate() {
            this.$api({
                url: '/InvoiceManagemnetPage/GetNewestInvoceFOO_DATE',
                method: 'GET',
            }).then((resp) => {
                this.newestInvoiceDate = resp.data.newestDate;
                console.log('invoice newest date: ', new Date(resp.data.newestDate));
            });
        },
        handleCancel() {
            this.$emit('canceled');
        },
        handleSubmit() {
            // 發票日期不可超過今天
            // const now = new Date();
            // const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
            // if (this.form.foO_DAT > today) {
            //     this.$message({
            //         showClose: true,
            //         message: '發票日期不可填寫未來日期。',
            //         type: 'error',
            //     });
            //     return;
            // }

            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        // 未開立過，送出帶發票資訊的審核
                        let url = '/InvoiceManagemnetPage/AuditInvoice';

                        // 已開立過，送出修改
                        if (this.foo) url = '/InvoiceManagemnetPage/UpdateAuditInfo';

                        this.isSubmitting = true;

                        const code = this.getInvoiceValidateCode(this.form);
                        if ((this.invoice.typ === 2 || this.invoice.typ === 3) && !code) {
                            await this.$confirm('您輸入的發票號碼不存在於發票日期所屬營業稅申報期別，確定要儲存嗎？', {
                                confirmButtonText: '確定',
                                cancelButtonText: '取消',
                            });
                        }

                        const data = { ...this.form, code };
                        console.log(data);

                        await this.$api({
                            url,
                            method: 'post',
                            data,
                        });
                        this.$emit('submitted');
                        if (this.invoice.typ !== 4) {
                            this.$message({
                                showClose: true,
                                message: '發票開立成功！',
                                type: 'success',
                            });
                        }

                        if (this.invoice.typ === 4) {
                            this.$message({
                                showClose: true,
                                message: '收入項目填寫完成',
                                type: 'success',
                            });
                        }
                    } catch (e) {
                        console.log(e);
                        if (e.response?.data === '重複操作，審核流程已更新。') this.$emit('submitted');
                    } finally {
                        this.isSubmitting = false;
                    }
                }
            });
        },
        getInvoiceValidateCode(item) {
            if (!item.foo) return undefined;
            const isIncome = true;
            const fooMonth = moment(item.foO_DAT).month() + 1;
            const fooYear = moment(item.foO_DAT).year();
            const fooKey = `${item.foo[0]}${item.foo[1]}`;
            const TYPE = _.chain(invoiceSerialNumber)
                .filter(['year', fooYear])
                .find((o) => o.month.includes(fooMonth))
                .get('datas')
                .find((o) => o.serialNumbers.includes(fooKey))
                .get('name')
                .value();

            const isCashierTripleInvoice = item.filE_TYP === 10;
            const TYPE_CODE = { A: 1, B: 2, D: 5 };
            if (TYPE) return Number(`${isIncome ? 3 : 2}${isCashierTripleInvoice ? 5 : TYPE_CODE[TYPE]}`);

            return undefined;
        },
        onVariableStateItemChange(val) {
            this.isAhSuggestAccountingItemsSelectorShow = true;
            this.$nextTick(() => {
                this.$refs.ahSuggestAccountingItemsSelector.setSuggestAccountItems(val);
            });
        },
        onAhSuggestAccountingItemsSelectorLoaded() {
            this.isAhSuggestAccountingItemsSelectorShow = this.isPayed('G01') || this.$store.getters['account/isSAAdmin'];
        },
        onRatTypeChange(val) {
            if (val === 1) {
                // 使用申請時匯率
                this.form.rat = this.invoice.rat;
            }
            if (val === 2) {
                // 使用即時匯率
                this.form.rat = this.getCnyRat(this.invoice.cny);
            }
            if (val === 3) {
                // 自訂（只是解開 disabled）
            }
        },
    },
};
</script>

<style lang="scss">
.invoice-check .future-invoice-alert {
    margin-top: 10px;
    line-height: 30px;

    .el-alert__description {
        margin-top: 0;
    }
}
</style>
